import { exitRegistration } from 'Utilities/registrationFlow';
import useAuth from './useAuth';

/**
 * Uses the existing sign-in and verification methods for account creation.
 * When registration, consent updates, or password recovery finishes, returns
 * the user to the standalone return URI instead of connecting a partner account.
 */
const useStandaloneAuth = () => {
  const auth = useAuth();
  return {
    ...auth,
    authenticateUserAndRedirect: exitRegistration,
    onConsentsUpdate: exitRegistration,
    handleForgotPasswordDone: exitRegistration,
    handleResetPasswordDone: exitRegistration
  };
};
export default useStandaloneAuth;